/**
 * Dev-only console logger.
 * In production builds we suppress console output; errors reach the user
 * via visible UI states, not the console.
 */
const isDev = process.env.NODE_ENV !== "production";

export const logError = (...args) => {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
};
